<template>
  <div class="select-container">
    <select
      class="form-control box_input_code"
      :value="selectedCode"
      @change="$emit('input', $event.target.value)"
      :class="{ error: isCodeInputInvalid }"
    >
      <option value="">Code</option>
      <option v-for="countryCode in countryCodes" :key="countryCode" :value="countryCode">
        +{{ countryCode }}
      </option>
    </select>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "GetCountriesCode",
  data() {
    return {
      code: "",
      countryCodes: [],
    };
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    isCodeInputInvalid: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    selectedCode: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
  },

  created() {
    this.getCountriesCode();
  },

  methods: {
    async getCountriesCode() {
      try {
        const apiUrl =
          "https://restcountries.com/v2/all?fields=name,flags,callingCodes";
        const response = await axios.get(apiUrl);
        const data = response.data;

        this.countryCodes = data
          .map((country) => country.callingCodes)
          .flat()
          .filter((code, index, self) => self.indexOf(code) === index)
          .sort();
      } catch (error) {
        console.error(error);
      }
    },

    updateFormValidation() {
      // Implement form validation logic here if needed
    },
  },
};
</script>

<style scoped lang="scss"></style>
